import Vue from 'vue'
import Locales from '../components/language/app.js'
import langEn from 'element-ui/lib/locale/lang/en'
import langCn from 'element-ui/lib/locale/lang/zh-CN'
import langKo from 'element-ui/lib/locale/lang/ko'
import langRu from 'element-ui/lib/locale/lang/ru-RU'
import langJP from 'element-ui/lib/locale/lang/ja'
import Vi from 'element-ui/lib/locale/lang/vi'
import locale from 'element-ui/lib/locale'

if (!localStorage.setlang) {
	localStorage.lang_jp = 'zh_cn'
}


const req = {
	common: {
		changeLang(lang) {
			let localLang = null
			// 如果lang==null则代表使用localStorage缓存的语言
			if (!lang || lang === 'undefined') {
				let oldLang = localStorage.getItem("lang_jp")
				if (oldLang !== null && oldLang !== "") {
					localLang = oldLang
				} else {
					localLang = "zh_cn"
				}
			} else {
				localLang = lang
			}
			localStorage.setItem("lang_jp", localLang)
			Vue.config.lang = localLang
			Object.keys(Locales).forEach(function(lang) {
				Vue.locale(lang, Locales[lang])
			})
			// 系统多语言
			let cLang = localStorage.getItem("lang_jp")
			switch (cLang) {
				case 'en':
					locale.use(langEn)
					break
				case 'zh_cn':
					locale.use(langCn)
					break
				case 'ko':
					locale.use(langKo)
					break
				case 'ru':
					locale.use(langRu)
					break
				case 'japan':
					locale.use(langJP)
				case 'vi':
					locale.use(Vi)
			}
		}
	}
}

export default req